module.exports = __webpack_public_path__ + "static/investment-advisory-services-hero-mobile.f11248d4.webp";